export default "__VITE_ASSET__61ad6e9a__"